import { createApp } from 'vue';

import { initCartActions } from '@/shared/instances/cart-button.js';
import { initHobbiiStarter } from '@/shared/instances/hobbii-starter';
import { initPatternDownload } from '@/shared/instances/pattern-download-button.js';
import { initQuantitySelector } from '@/shared/instances/quantity-selector.js';
import { useProductStore } from '@/shared/pinia/modules/product';
import { getProductDataFromHTML } from '@/shared/utils/product';

import { initProductInfoTabs } from './shared/product-info-tabs.ts';
import {
  initDropdownOptions,
  initGalleryOptions,
  initSingleOption
} from './shared/product-options.js';
import {
  initPatternProductsPreview,
  initTabCounters,
  initYarnPatternsTabCount
} from './shared/product-tab-async.ts';
import { setReadMoreListeners } from './shared/read-more.ts';

const optionsMountId = 'js-product-options';
const cartActionsMountId = 'js-product-cart-actions';
const quantityPickerMountId = 'js-product-quantity-selector';

// set option selector
const initOptionsSelector = () => {
  const elem = document.getElementById(optionsMountId);

  const optionKind = elem?.dataset.optionKind;
  const type = optionKind ? JSON.parse(optionKind) : null;

  switch (type?.layout) {
    case 'gallery':
      initGalleryOptions(createApp, optionsMountId);
      break;
    case 'dropdown':
      initDropdownOptions(createApp, optionsMountId);
      break;
    default: {
      initSingleOption(optionsMountId);
    }
  }
};

const initProductPageApps = async () => {
  const {
    productId,
    variantId,
    legacyId,
    entityType,
    pointCost,
    productMainImageUrl,
    productName
  } = getProductDataFromHTML();

  const productStore = useProductStore();

  if (entityType) {
    productStore.entityType = entityType;
  }
  if (productId) {
    productStore.productId = productId;
  }
  if (productName) {
    productStore.productName = productName;
  }
  if (variantId) {
    productStore.variantId = variantId;
  }
  if (legacyId) {
    productStore.legacyId = legacyId;
  }

  if (pointCost && Number(pointCost) > 0) {
    productStore.pointsPrice = Number(pointCost);
  }

  if (productMainImageUrl) {
    productStore.mainImageUrl = productMainImageUrl;
  }

  if (productStore.isPattern) {
    // TODO perhaps use hide / show on the product page instead of this
    initPatternDownload(createApp, 'pattern-download-button');

    const { isFreePattern } = getProductDataFromHTML();
    if (isFreePattern === 'true') {
      productStore.purchasable = false;
    }
  }

  // TODO Check store
  // TODO set cart item preview / modal

  if (productStore.isProduct) {
    initOptionsSelector();
  }
  initCartActions(createApp, cartActionsMountId);
  initQuantitySelector(createApp, quantityPickerMountId);
  initProductInfoTabs();
  initTabCounters();
  initPatternProductsPreview();
  initYarnPatternsTabCount();

  setReadMoreListeners();
};

initHobbiiStarter();
initProductPageApps();
